const CheckIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="14"
      viewBox="0 0 20 14"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4953 0.81504C20.1632 1.45734 20.1632 2.52046 19.4953 3.16277L8.73822 13.5061C8.39271 13.8383 7.95506 13.9933 7.5174 13.9933C7.07975 13.9933 6.6421 13.8383 6.29658 13.5061L0.929586 8.34549C0.26159 7.70319 0.26159 6.64007 0.929586 5.99776C1.59758 5.35546 2.70323 5.35546 3.37122 5.99776L7.5174 9.98447L17.0536 0.81504C17.7216 0.172737 18.8273 0.172737 19.4953 0.81504Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CheckIcon;
